import { useSelector } from "../../redux/hooks";
import { useController, useFormContext } from "react-hook-form";
import { Autocomplete } from "@mantine/core";

interface Props {
  id: string;
  value: string;
  tag: string;
}
const IomParticulars = ({ id, value, tag }: Props) => {
  const { control } = useFormContext();
  const { field } = useController({ name: id, control, defaultValue: value });
  const { yachtData } = useSelector(state => state.generatorSlice);
  return (
    <Autocomplete data={yachtData?.iom?.[tag ?? ""]?.list ?? []} {...field} />
  );
};
export default IomParticulars;
